import clsx from 'clsx';
import { Alert } from 'antd';
import { IOpInfoProps } from '../OpInfo';

import '../OpInfo.scss';

export const OpInfoWithoutDismiss = ({
  className,
  ...alertProps
}: IOpInfoProps) => (
  <Alert className={clsx('op-info', className)} showIcon {...alertProps} />
);
